import classNames from "classnames";

import { useSimilarAnswersContext } from "./SimilarAnswersContext";
import SimilarAnswersDismissedPrompt from "./SimilarAnswersDismissedPrompt";
import SimilarAnswersReviewedPrompt from "./SimilarAnswersReviewedPrompt";
import SimilarAnswersSuggestionsPrompt from "./SimilarAnswersSuggestionsPrompt";

// Renders the suggestion state card. Reads shared state from SimilarAnswersContext
// and delegates funnel lifecycle (open/close, seek-more, reset) entirely to the
// parent SimilarAnswersSuggestions, which keeps that state alive across loading phases.
const SimilarAnswersSuggestionsBox = ({ className }) => {
  const { suggestionsDismissed, suggestionsReviewed, onOpenFunnel, onReset } =
    useSimilarAnswersContext();

  const boxClassName = classNames([
    "similar-answers-suggestions",
    "box",
    "margin-y-sm",
    "border",
    "padding-sm",
    className,
    {
      "border-primary": !suggestionsReviewed,
      "border-success": suggestionsReviewed
    }
  ]);

  return (
    <div className={boxClassName}>
      {suggestionsDismissed && <SimilarAnswersDismissedPrompt onReset={onReset} />}

      {!suggestionsDismissed && suggestionsReviewed && (
        <SimilarAnswersReviewedPrompt onReset={onReset} />
      )}

      {!suggestionsDismissed && !suggestionsReviewed && (
        <SimilarAnswersSuggestionsPrompt onOpenFunnel={onOpenFunnel} />
      )}
    </div>
  );
};

export default SimilarAnswersSuggestionsBox;
